import { Input } from 'antd';
import React from 'react'
import PhoneInput from "react-phone-number-input";

const UserEmergencyContactV3 = ({ emergencyName, setEmergencyName, emergencyContact, setEmergencyContact, relationship, setRelationShip }) => {

    const handlePhoneChange = (value) => {
        setEmergencyContact(value);
    };

    return (
        <div style={{ width: '100%', height: '100%', padding: '30px 24px 20px 24px' }}>
            <div style={{ color: '#AEAEAE', fontSize: 18, fontWeight: 400, marginBottom: 16 }}>Emergency contact</div>
            <div style={{ display: 'flex', flexWrap: "wrap", justifyContent: 'space-between', width: '100%', marginTop: '2%' }}>
                <div style={{ width: '30%', }}>
                    <label style={{ color: '#636363', fontWeight: 400, fontSize: 12, }}>Name</label>
                    <Input
                        style={{ border: 'none', borderBottom: '1px solid #E6E6E6', padding: '0px 0px 5px 0px', marginTop: 5 }}
                        bordered={null}
                        inputId={"-998"}
                        value={emergencyName}
                        onChange={(e) => setEmergencyName(e.target.value)}

                    />
                </div>
                <div style={{ width: '30%' }}>
                    <label style={{ color: '#636363', fontWeight: 400, fontSize: 12 }}>Mobile No.</label>
                    <PhoneInput
                        className="emergency-contact PhoneInputV3"
                        defaultCountry="IN"
                        placeholder={"Enter mobile number"}
                        height={"40px"}
                        value={emergencyContact}
                        onChange={handlePhoneChange}
                        style={{ border: 'none', borderBottom: '1px solid #E6E6E6' }}
                        // maxLength={emergencyContact?.startsWith('+91') && emergencyContact?.length === 13 ? 11 : ""}
                        maxLength={
                            emergencyContact &&
                                typeof emergencyContact === 'string' &&
                                emergencyContact.startsWith('+91') &&
                                emergencyContact.length === 13 ? 11 : ""
                        }
                        addInternationalOption={true}
                    />
                </div>
                <div style={{ width: '30%', }}>
                    <label style={{ color: '#636363', fontWeight: 400, fontSize: 12, }}>Relationship</label>
                    <Input
                        style={{ border: 'none', borderBottom: '1px solid #E6E6E6', padding: '0px 0px 5px 0px', marginTop: 5 }}
                        bordered={null}
                        inputId={"-998"}
                        value={relationship}
                        onChange={(e) => setRelationShip(e.target.value)}
                    />

                </div>

            </div>
        </div>
    )
}

export default UserEmergencyContactV3